/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Sound_Impala_ChopInputs */

const fr_gray_sound_impala_chop = /** @type {(inputs: Gray_Sound_Impala_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la séance`)
};

/**

* @param {Gray_Sound_Impala_ChopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const gray_sound_impala_chop = /** @type {((inputs?: Gray_Sound_Impala_ChopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Sound_Impala_ChopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_gray_sound_impala_chop(inputs)
});